import React, { useEffect } from "react";
import { useFormikContext } from "formik";

function UpdateTabs({ setTabs }) {
  const { values } = useFormikContext();

  useEffect(() => {
    if (values.general.cmr_type === "business") {
      setTabs([
        "General Info",
        "Contacts",
        "Banking",
        "Payment",
        "Accounting",
        "Address",
      ]);
    } else {
      setTabs([
        "General Info",
        "Contacts",
        "Banking",
        "Payment",
        "Accounting",
        "Address",
        "Patient Info",
        "Family Info",
        "Insurance",
      ]);
    }
  }, [values.general.cmr_type]);

  return null;
}

export default UpdateTabs;
